const LANGCHAIN_INTEGRATION_NAME = "LangChain";
const LANGCHAIN_ORIGIN = "auto.ai.langchain";
const ROLE_MAP = {
  human: "user",
  ai: "assistant",
  assistant: "assistant",
  system: "system",
  function: "function",
  tool: "tool"
};

export { LANGCHAIN_INTEGRATION_NAME, LANGCHAIN_ORIGIN, ROLE_MAP };
//# sourceMappingURL=constants.js.map
